// extracted by css-extract-rspack-plugin
var _1 = "QHQgploih_ALDkyq";
export { _1 as "wrapperStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "QHQgploih_ALDkyq";
export { _1 as "wrapperStyle" }
